import React from "react";
import { Flame, Feather, Star, Leaf, Waves, Circle, Heart } from "lucide-react";

const MAP = {
  candle: Flame,
  dove: Feather,
  star: Star,
  leaf: Leaf,
  wave: Waves,
  circle: Circle,
  heart: Heart,
};

export function SymbolIcon({ name, size = 22, strokeWidth = 1.5, className = "" }) {
  const Icon = MAP[name] || Circle;
  return <Icon size={size} strokeWidth={strokeWidth} className={className} />;
}

export const SYMBOL_KEYS = ["candle", "dove", "star", "leaf", "wave", "circle", "heart"];
